import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

/** Longest value the backend encrypts (Backend-@Size). */
export const SECRET_VALUE_MAX = 512;

const ENCRYPTED_VALUE = /^ENC:[A-Za-z0-9+/]+={0,2}$/;

/** Same pattern as the backend and the engine, so all three agree on what counts as encrypted. */
export function isEncryptedValue(value: string): boolean {
  return ENCRYPTED_VALUE.test(value);
}

interface SecretEncryptResponse {
  readonly value: string;
}

@Injectable({ providedIn: 'root' })
export class SecretService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/api/v1/projects`;

  encrypt(projectId: string, value: string): Observable<string> {
    return this.http
      .post<SecretEncryptResponse>(`${this.base}/${projectId}/secrets/encrypt`, { value })
      .pipe(map((response) => response.value));
  }
}
